// utils/formatContact.js
import { logDev } from "../utils/logger.js";

  export const formatContact = (item, periodes = []) => {
  if (!item || typeof item !== "object") return {};

  const base = {
    id: item._id,              // 👈 obligatoire pour MUI DataGrid
    _id: item._id,             // tu peux garder l’original si besoin
    contact: item.nom,
    nom: item.nom,
    mail: item.mail || "",
    telephone: item.telephone || "",
    combien: item.combien || 0,
    virements: item.virements || []
  };

  // 🔹 Mapper chaque période dynamique
  periodes.forEach((periode) => {
    /*const key = `periode${index + 1}`;*/
    const key = periode._id; // 👈 identifiant réel

    // Cherche si ce contact a une entrée pour cette période
    const match = (item.periodes || []).find(
      p => String(p.periodeId) === String(periode._id)
    );

    // Si trouvé → on prend sa valeur, sinon 0
    /*base[key] = match ? Number(match.valeur || 0) : 0;*/
    base[key] = match?.valeur ?? "";
  });

  logDev("[formatContact] contact formaté", base);

  return base;
};
